module.exports = __webpack_public_path__ + "assets/images/clients/22.png";